import { preloadPostOfficePlacementWithSessionContext } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

export const preloadPostOfficeConfluenceHomeBanner = async (): Promise<boolean> => {
	return preloadPostOfficePlacementWithSessionContext('confluence-home-banner');
};
